import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Util from '../../common/utilities/';
import { default as Actions } from '../actions';
import { default as ECSActions } from '../../ecs/actions';
import * as CommonActions from '../../common/actions';

import {
  ExperimentBlockConfiguration,
  ExperimentBlockError
} from '../components';
import { default as FlagsProvider } from '../../flags/Flags';
import { Spinner } from '@salesforce/design-system-react';

import '../../ecs/containers/ContentBlock.scss';

export class ExperimentBlock extends Component {
  componentDidMount() {
    this.props.actions.searchExperiments(
      {},
      { page: 1 },
      { context: 'block', mode: 'reset' }
    );
    this.props.actions.getBlockDataFromSdk();
    this.props.actions.getCentralDataFromSdk();
  }

  handleConfigurationChange(field, data) {
    this.props.actions.updateForm(field, data);
    this.props.actions.getExperiment(
      data?.experiment?.selection?.[0]?.id,
      'block'
    );
  }

  componentDidUpdate(prevProps) {
    // Form was changed, save data to blocksdk
    if (Util.propChanged(prevProps, this.props, 'forms.selection')) {
      // always save the block data back into the sdk on any change
      const selection = this.props.forms.selection;
      selection.id = this.props.forms.selection?.experiment?.selection?.[0].id;
      this.props.actions.saveBlockDataInSdk(selection);
    }

    // Block data was loaded from blocksdk, convert saved block back to selection
    if (Util.propChanged(prevProps, this.props, 'block.isDataLoading', false)) {
      const data = this.props.block?.data;
      if (data) {
        const isExistingBlock = !!data.id;
        this.props.actions.updateForm('selection', {
          ...data,
          isExistingBlock
        });
        if (isExistingBlock) {
          this.props.actions.getExperiment(data.id, 'block');
        }
      }
    }
  }

  error() {
    if (
      !this.props.experiments.isLoading &&
      this.props.experiments.hasLoadedOnce
    ) {
      if (this.props.experiments.error) {
        return 'session';
      } else if (
        this.props.experiments?.data?.search?.block?.experiments &&
        this.props.experiments?.data?.search?.block?.experiments.length <= 0
      ) {
        return 'noexperiments';
      }
    }
    return false;
  }

  renderSpinner() {
    return (
      <div className="spinner">
        <Spinner
          size="large"
          variant="brand"
          assistiveText={{ label: 'Large spinner' }}
        />
      </div>
    );
  }

  renderError(err) {
    return (
      <div className="block-config-home">
        <ExperimentBlockError error={err} />
      </div>
    );
  }

  renderBlock() {
    return (
      <FlagsProvider>
        <div className="block-config-home">
          <ExperimentBlockConfiguration
            actions={this.props.actions}
            experiments={this.props.experiments?.data}
            forms={this.props.forms}
            formChange={this.handleConfigurationChange.bind(this)}
          />
        </div>
      </FlagsProvider>
    );
  }

  render() {
    const err = this.error();
    if (err) {
      return this.renderError(err);
    } else {
      return this.props.experiments.isLoading
        ? this.renderSpinner()
        : this.renderBlock();
    }
  }
}

ExperimentBlock.contextTypes = {
  router: PropTypes.object
};

ExperimentBlock.propTypes = {
  actions: PropTypes.shape({
    searchExperiments: PropTypes.func,
    getBlockDataFromSdk: PropTypes.func,
    getUserDataFromSdk: PropTypes.func,
    setExperimentContentInSdk: PropTypes.func,
    setSuperContentInSdk: PropTypes.func,
    saveBlockDataInSdk: PropTypes.func,
    updateForm: PropTypes.func
  }),
  block: PropTypes.object,
  experiments: PropTypes.object,
  form: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    block: state.ecs.block,
    experiments: state.experiments,
    flags: state.ecs.flags,
    forms: state.forms,
    modals: state.modals
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...Actions, ...ECSActions, ...CommonActions },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExperimentBlock);
